module.exports = __webpack_public_path__ + "img/role-girl-base.a996b2d1.png";